import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../utils/axiosInstance";

const ConfirmModal = ({ onConfirm, onCancel }) => (
  <div onClick={onCancel} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
    <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 18, width: "100%", maxWidth: 380, boxShadow: "0 20px 60px rgba(0,0,0,0.25)", overflow: "hidden" }}>
      <div style={{ padding: "28px 28px 20px", textAlign: "center" }}>
        <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
          <i className="bi bi-trash3-fill" style={{ fontSize: 24, color: "#dc2626" }} />
        </div>
        <h5 style={{ margin: "0 0 8px", fontWeight: 700, color: "#111827", fontSize: 17 }}>Siba Ikibazo</h5>
        <p style={{ margin: 0, color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>
          Urashaka gusiba iki kibazo burundu?<br />
          <span style={{ color: "#dc2626", fontWeight: 600 }}>Ibi ntibishobora gusubirwaho.</span>
        </p>
      </div>
      <div style={{ display: "flex", gap: 10, padding: "0 28px 24px" }}>
        <button onClick={onCancel} style={{ flex: 1, padding: "10px 0", background: "#f3f4f6", border: "1px solid #e5e7eb", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: "pointer", color: "#374151" }}>
          Reka
        </button>
        <button onClick={onConfirm} style={{ flex: 1, padding: "10px 0", background: "#dc2626", border: "none", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: "pointer", color: "#fff" }}>
          <i className="bi bi-trash me-1" /> Yego, Siba
        </button>
      </div>
    </div>
  </div>
);

const fmtDate = (d) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "short", day: "numeric" }); }
  catch { return d; }
};

const StatusBadge = ({ status }) => {
  const map = {
    pending:  { bg: "#fef3c7", color: "#b45309", border: "#fde68a", label: "⏳ Itegereje" },
    answered: { bg: "#dcfce7", color: "#15803d", border: "#bbf7d0", label: "✅ Yasubijwe" },
  };
  const s = map[status] || map.pending;
  return (
    <span style={{ fontSize: "0.72rem", fontWeight: 700, padding: "3px 10px", borderRadius: 20,
      background: s.bg, color: s.color, border: `1px solid ${s.border}`, whiteSpace: "nowrap" }}>
      {s.label}
    </span>
  );
};

const IbibazoByanye = () => {
  const [problems, setProblems] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState("");
  const [selected, setSelected] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [confirmId, setConfirmId] = useState(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/api/questions/mine");
      setProblems(Array.isArray(res.data) ? res.data : []);
    } catch { setProblems([]); }
    finally { setLoading(false); }
  }, []);

  const handleDelete = (e, id) => {
    e.stopPropagation();
    setConfirmId(id);
  };

  const confirmDelete = async () => {
    const id = confirmId;
    setConfirmId(null);
    setDeleting(id);
    try {
      await axiosInstance.delete(`/api/questions/${id}`);
      setProblems(prev => prev.filter(p => p.id !== id));
      if (selected?.id === id) setSelected(null);
    } catch { alert("Gusiba byanze. Ongera ugerageze."); }
    finally { setDeleting(null); }
  };

  useEffect(() => { fetch(); }, [fetch]);

  const filtered = problems.filter(p =>
    (p.title || "").toLowerCase().includes(search.toLowerCase()) ||
    (p.message || "").toLowerCase().includes(search.toLowerCase())
  );

  const unread = problems.filter(p => p.status === "answered" && !p.seen).length;

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", padding: "0 4px" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: "#1a2332", margin: 0, display: "flex", alignItems: "center", gap: 8 }}>
            <i className="bi bi-inbox-fill" style={{ color: "#7c3aed" }} />
            Ibibazo Byanjye
            {unread > 0 && (
              <span style={{ background: "#dc2626", color: "#fff", borderRadius: 20, padding: "2px 8px", fontSize: 12, fontWeight: 700 }}>
                {unread} bishya
              </span>
            )}
          </h2>
          <p style={{ color: "#6b7280", fontSize: 13, marginTop: 4 }}>
            Ibibazo wohereje Akagari — {problems.length} ibibazo
          </p>
        </div>
        <button onClick={fetch} style={{ padding: "9px 18px", background: "#7c3aed", color: "#fff", border: "none", borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
          <i className="bi bi-arrow-clockwise" /> Vugurura
        </button>
      </div>

      {/* Search */}
      <div style={{ position: "relative", marginBottom: 16 }}>
        <i className="bi bi-search" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", fontSize: 14 }} />
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Shakisha ikibazo..."
          style={{ width: "100%", padding: "10px 12px 10px 36px", border: "1px solid #e5e7eb", borderRadius: 10, fontSize: 14, outline: "none", background: "#fff", boxSizing: "border-box" }} />
      </div>

      {/* Loading */}
      {loading && (
        <div style={{ textAlign: "center", padding: "60px 20px" }}>
          <div className="spinner-border text-primary" style={{ width: 40, height: 40 }} />
          <p style={{ color: "#6b7280", marginTop: 12, fontSize: 14 }}>Gutegereza...</p>
        </div>
      )}

      {/* Empty */}
      {!loading && filtered.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 20px", background: "#fff", borderRadius: 14, border: "1px solid #e5e7eb" }}>
          <i className="bi bi-inbox" style={{ fontSize: 48, color: "#d1d5db", display: "block", marginBottom: 12 }} />
          <h5 style={{ color: "#374151", fontWeight: 700 }}>Nta kibazo kibonetse</h5>
          <p style={{ color: "#9ca3af", fontSize: 14 }}>
            {search ? "Hindura amagambo yo gushakisha" : "Ntabwo wohereje ikibazo narimwe"}
          </p>
        </div>
      )}

      {/* List */}
      {!loading && filtered.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {filtered.map(p => (
            <div key={p.id} onClick={() => setSelected(p)}
              style={{ background: "#fff", border: `1px solid ${p.status === "answered" ? "#bbf7d0" : "#e5e7eb"}`,
                borderLeft: `4px solid ${p.status === "answered" ? "#16a34a" : "#7c3aed"}`,
                borderRadius: 14, padding: 16, cursor: "pointer", boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                transition: "box-shadow 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(124,58,237,0.12)"}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.05)"}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
                <div style={{ flex:1, minWidth: 0 }}>
                  <p style={{ color: "#6b7280", fontSize: 13, margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 400 }}>
                    {p.question_text}
                  </p>
                  <div style={{ marginTop: 8, fontSize: 12, color: "#9ca3af" }}>
                    <i className="bi bi-calendar me-1" />{fmtDate(p.created_at)}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <StatusBadge status={p.status} />
                  <button
                    onClick={e => handleDelete(e, p.id)}
                    disabled={deleting === p.id}
                    title="Siba ikibazo"
                    style={{ background: "#fee2e2", border: "1px solid #fca5a5", borderRadius: 8, padding: "4px 10px", cursor: "pointer", color: "#dc2626", fontSize: 13, fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}
                  >
                    {deleting === p.id
                      ? <span className="spinner-border spinner-border-sm" />
                      : <><i className="bi bi-trash" /> Siba</>}
                  </button>
                </div>
              </div>
              {p.status === "answered" && p.answer && (
                <div style={{ marginTop: 12, padding: "10px 14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#15803d", textTransform: "uppercase", marginBottom: 4 }}>
                    <i className="bi bi-chat-dots-fill me-1" />Igisubizo cy'Akagari:
                  </div>
                  <div style={{ fontSize: 13, color: "#374151" }}>{p.answer}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Detail Modal */}
      {selected && (
        <div onClick={() => setSelected(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 18, width: "100%", maxWidth: 560, maxHeight: "88vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
            <div style={{ padding: "18px 22px", borderBottom: "1px solid #e5e7eb", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0, background: "#fff", zIndex: 5 }}>
              <h5 style={{ margin: 0, fontWeight: 700, color: "#111827", fontSize: 16 }}>
                <i className="bi bi-chat-square-text me-2" style={{ color: "#7c3aed" }} />
                {selected.title}
              </h5>
              <button onClick={() => setSelected(null)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#6b7280" }}>✕</button>
            </div>
            <div style={{ padding: 22 }}>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", marginBottom: 6 }}>Ikibazo Cyawe</div>
                <div style={{ background: "#f9fafb", borderRadius: 10, padding: "12px 14px", fontSize: 14, color: "#374151", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{selected.question_text}</div>
              </div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: "#6b7280" }}><i className="bi bi-calendar me-1" />{fmtDate(selected.created_at)}</div>
                <StatusBadge status={selected.status} />
              </div>
              {selected.status === "answered" && selected.answer ? (
                <div style={{ padding: "14px 16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#15803d", textTransform: "uppercase", marginBottom: 8 }}>
                    <i className="bi bi-chat-dots-fill me-1" />Igisubizo cy'Akagari
                  </div>
                  <div style={{ fontSize: 14, color: "#374151", lineHeight: 1.7 }}>{selected.answer}</div>
                  {selected.answered_at && (
                    <div style={{ fontSize: 11, color: "#6b7280", marginTop: 8 }}>
                      <i className="bi bi-clock me-1" />{fmtDate(selected.answered_at)}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ padding: "12px 16px", background: "#fef3c7", border: "1px solid #fde68a", borderRadius: 12, display: "flex", alignItems: "center", gap: 8 }}>
                  <div className="spinner-border spinner-border-sm text-warning" />
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#b45309" }}>Tegereza igisubizo cy'Akagari...</span>
                </div>
              )}
              <button onClick={() => setSelected(null)} style={{ marginTop: 20, width: "100%", padding: 11, background: "#f3f4f6", border: "1px solid #e5e7eb", borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: "pointer", color: "#374151" }}>
                Funga
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmId && <ConfirmModal onConfirm={confirmDelete} onCancel={() => setConfirmId(null)} />}
    </div>
  );
};

export default IbibazoByanye;
